<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import defaultEmployeeImage from "@/assets/images/user.png";
import { computed, ref, watch } from "vue";

const props = defineProps({
  employee: Object,
  withoutLink: Boolean,
  isShowLastName: {
    type: Boolean,
    default: true
  }
});

const baseUrl = ref(process.env.VUE_APP_BASE_URI);
const currentImageUrl = ref(defaultEmployeeImage);

const employeeImageUrl = computed(() => {
  if (!props.employee?.photo?.contentUrl) {
    return defaultEmployeeImage;
  }
  return baseUrl.value + props.employee.photo.contentUrl;
});

watch(employeeImageUrl, (imageUrl) => {
  currentImageUrl.value = imageUrl;
}, { immediate: true });

function useDefaultImage() {
  currentImageUrl.value = defaultEmployeeImage;
}
</script>

<template>
  <div class="row-table-image-name-link">
    <div
        class="media pointer"
    >
      <img
          class="rounded-circle img-thumbnail"
          :src="currentImageUrl"
          :alt="'Employee image'"
          :title="'Click para ampliar'"
          @error="useDefaultImage"
      >
    </div>

    <div
        v-if="employee && employee.id && !withoutLink"
        class="link-name"
    >
      <router-link :to="{name: 'employee', params: { id: employee.id }}">
        <div v-if="isShowLastName">
          {{ employee.name }} {{ employee.lastName }}
        </div>
        <div v-if="!isShowLastName">
          {{ employee.name }}
        </div>
      </router-link>
    </div>
    <div
        v-if="employee && employee.id && withoutLink"
        class="link-name"
    >
      <div v-if="isShowLastName">
        {{ employee.name }} {{ employee.lastName }}
      </div>
      <div v-if="!isShowLastName">
        {{ employee.name }}
      </div>
    </div>
  </div>
</template>

<style
    lang="scss"
    scoped>
.link-name {
  margin: auto;
  margin-left: 10px;
}

.img-thumbnail {
  width: 50px;
  min-width: 50px;
}

.row-table-image-name-link {
  display: flex;
  align-items: center;
  gap: 4px;
}

</style>
